import React from "react";
import Table1Header from "./table1Header";
import Table1Body from "./table1Body";

const Table1 = ({columns, baseInformation, sortColumn, handleSort, handleChange, data, itemsMap, itemList}) => {
    return (
        <table className="table">
            <Table1Header
                columns={columns}                   // TODO
                baseInformation={baseInformation}
                sortColumn={sortColumn}
                handleSort={handleSort}
            />
            <Table1Body
                data={data}
                columns={columns}                   // TODO
                baseInformation={baseInformation}
                handleChange={handleChange}
                itemsMap={itemsMap}                 // TODO
                itemList={itemList}                 // TODO

            />
        </table>
    );
};

export default Table1;
